import { render, staticRenderFns } from "./RowMeasures.vue?vue&type=template&id=04b6f974&scoped=true"
import script from "./RowMeasures.vue?vue&type=script&lang=js"
export * from "./RowMeasures.vue?vue&type=script&lang=js"
import style0 from "./RowMeasures.vue?vue&type=style&index=0&id=04b6f974&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6f974",
  null
  
)

export default component.exports